// extracted by mini-css-extract-plugin
export default {"linkBack":"style--linkBack--987fd3"};